/** 胜场荣誉头衔。排行榜名字右侧的小木牌由此表派生。 */

export type HonorTitle = {
  minWins: number;
  name: string;
  /** 木牌描边 */
  stroke: string;
  /** 头衔文字 */
  text: string;
  /** 木牌底色 */
  wood: string;
  strokeWidth: number;
  /** 封顶档：洒金细线 + 内描 */
  gilt: boolean;
};

export const HONOR_PLAQUE_W = 50;
export const HONOR_PLAQUE_H = 18;

export const HONOR_TITLES: readonly HonorTitle[] = [
  { minWins: 0, name: "听书客", stroke: "#5C554E", text: "#5C554E", wood: "#E7D8C2", strokeWidth: 1.35, gilt: false },
  { minWins: 8, name: "接令客", stroke: "#4A5A4E", text: "#3E4E42", wood: "#E4D8C0", strokeWidth: 1.35, gilt: false },
  { minWins: 20, name: "对句友", stroke: "#6B4530", text: "#5A3A28", wood: "#E8D3B4", strokeWidth: 1.4, gilt: false },
  { minWins: 40, name: "联句客", stroke: "#2A3F52", text: "#243848", wood: "#E4D6C0", strokeWidth: 1.4, gilt: false },
  { minWins: 70, name: "捷才生", stroke: "#3F6E6B", text: "#2F5A58", wood: "#E3D8C2", strokeWidth: 1.4, gilt: false },
  { minWins: 110, name: "博闻士", stroke: "#5E4E58", text: "#4E4048", wood: "#E6D4B8", strokeWidth: 1.45, gilt: false },
  { minWins: 160, name: "妙语家", stroke: "#452F3A", text: "#3A2630", wood: "#E8D2B6", strokeWidth: 1.45, gilt: false },
  { minWins: 220, name: "文采郎", stroke: "#6E2626", text: "#5C1E1E", wood: "#EBD3B4", strokeWidth: 1.5, gilt: false },
  { minWins: 300, name: "雅集贤", stroke: "#B89B5E", text: "#8A6A28", wood: "#F2E4C0", strokeWidth: 0.9, gilt: true },
] as const;

function clampWins(wins: number): number {
  if (!Number.isFinite(wins)) return 0;
  return Math.max(0, Math.floor(wins));
}

export function honorIndexFromWins(wins: number): number {
  const n = clampWins(wins);
  let idx = 0;
  for (let i = 0; i < HONOR_TITLES.length; i++) {
    const row = HONOR_TITLES[i];
    if (row && n >= row.minWins) idx = i;
  }
  return idx;
}

const FALLBACK_HONOR: HonorTitle = HONOR_TITLES[0] ?? {
  minWins: 0,
  name: "听书客",
  stroke: "#5C554E",
  text: "#5C554E",
  wood: "#E7D8C2",
  strokeWidth: 1.35,
  gilt: false,
};

export function honorFromWins(wins: number): HonorTitle {
  return HONOR_TITLES[honorIndexFromWins(wins)] ?? FALLBACK_HONOR;
}

export function honorNameFromWins(wins: number): string {
  return honorFromWins(wins).name;
}

/** 胜场从 prev 增到 next 时新点亮的头衔；未晋升则 null。 */
export function honorPromoted(prevWins: number, nextWins: number): HonorTitle | null {
  const before = honorIndexFromWins(prevWins);
  const after = honorIndexFromWins(nextWins);
  if (after <= before) return null;
  return HONOR_TITLES[after] ?? null;
}
